module.exports = __webpack_public_path__ + "static/media/khra_bakhra.8f3fd1f0.ogg";